import type { RouteObject } from 'react-router-dom';
import NotFound from '../pages/NotFound';
import Home from '../pages/home/page';
import About from '../pages/about/page';
import Services from '../pages/services/page';
import LawnMowerRepair from '../pages/services/lawn-mower/page';
import SnowBlowerRepair from '../pages/services/snow-blower/page';
import GeneratorRepair from '../pages/services/generator/page';
import Contact from '../pages/contact/page';
import Consultation from '../pages/consultation/page';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/about',
    element: <About />,
  },
  {
    path: '/services',
    element: <Services />,
  },
  {
    path: '/services/lawn-mower',
    element: <LawnMowerRepair />,
  },
  {
    path: '/services/snow-blower',
    element: <SnowBlowerRepair />,
  },
  {
    path: '/services/generator',
    element: <GeneratorRepair />,
  },
  {
    path: '/contact',
    element: <Contact />,
  },
  {
    path: '/consultation',
    element: <Consultation />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
